document.addEventListener('DOMContentLoaded', function() {
  console.log('Video player loaded');

  // Получаем элемент видео
  const videoWrapper = document.querySelector('.video-wrapper');

  // Если элемент найден, проверяем наличие в нем YouTube URL
  if (videoWrapper) {
    console.log('Video wrapper found:', videoWrapper);

    // Проверяем, содержит ли элемент URL YouTube в атрибуте или в текстовом содержимом
    const youtubeUrl = videoWrapper.getAttribute('data-media-path') ||
                      videoWrapper.textContent ||
                      videoWrapper.innerHTML;

    if (youtubeUrl && youtubeUrl.includes('youtube.com')) {
      console.log('YouTube URL found:', youtubeUrl);

      // Извлекаем ID видео
      const videoId = extractYoutubeId(youtubeUrl);
      if (videoId) {
        console.log('YouTube video ID extracted:', videoId);

        // Сохраняем ID видео для использования при клике
        videoWrapper.setAttribute('data-video-id', videoId);
      }
    }

    // Добавляем обработчик клика
    videoWrapper.addEventListener('click', function() {
      // Получаем ID видео - либо из атрибута, либо извлекаем из URL
      const videoId = videoWrapper.getAttribute('data-video-id') ||
                     extractYoutubeId(videoWrapper.getAttribute('data-media-path')) ||
                     'h8IoMbV5dss'; // Используем дефолтное значение как fallback

      playVideo(videoId);
    });
  }

  function playVideo(videoId) {
    // Создаем YouTube iframe
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.frameBorder = '0';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.style.borderRadius = 'inherit';

    // Заменяем содержимое wrapper на iframe
    if (videoWrapper) {
      videoWrapper.innerHTML = '';
      videoWrapper.appendChild(iframe);
    }
  }

  // Функция для извлечения ID видео из URL YouTube
  function extractYoutubeId(url) {
    if (!url) return null;

    // Если это просто ID видео
    if (/^[a-zA-Z0-9_-]{11}$/.test(url)) {
      return url;
    }

    // YouTube URL форматы
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url && url.match ? url.match(regExp) : null;

    return (match && match[2] && match[2].length === 11) ? match[2] : null;
  }
});